import { Directive, ElementRef, HostListener, Input, OnInit, OnDestroy } from '@angular/core';
import { SohoTooltipDirective } from 'ids-enterprise-ng';

@Directive({ selector: '[lm-tooltip]', standalone: false })
export class LMTooltipDirective implements OnInit, OnDestroy {
  @Input() placement: SohoTooltipOffset = 'top';
  @Input() showOnKeyboardFocus = false;
  @Input() content = '';

  private tooltip: SohoTooltipDirective = null;

  constructor(
    private element: ElementRef
  ) {}

  ngOnInit() {
    this.applyStyleOverflowEllipsis();
  }

  ngOnDestroy() {
    if (this.tooltip) {
      const tooltip = this.tooltip as SohoTooltipDirective;
      tooltip.ngOnDestroy();
    }
  }

  private isTooltipNeeded(): boolean {
    const nativeElement = this.element.nativeElement;
    const children = nativeElement.children;
    let childHasLineClamp = false;

    Array.from(children).forEach((element: HTMLElement) => {
      const style = window.getComputedStyle(element);
      if (Number(style.getPropertyValue('-webkit-line-clamp')) >= 1) {
        childHasLineClamp =  true;
      }
    });

    // tooltip is needed if element is using line clamp
    if (childHasLineClamp) {
      return true;
    }

    if (nativeElement?.placeholder) {
      const width = this.element.nativeElement.placeholder.length * 10.5; // estimated width of individual character
      return width > this.element.nativeElement.offsetWidth;
    }

    return this.element.nativeElement.offsetWidth < this.element.nativeElement.scrollWidth;
  }

  @HostListener('mouseenter', [ '$event']) onMouseEnter(event: MouseEvent) {
    this.show();
  }

  public show() {
    if (!this.isTooltipNeeded()) 
      return;

    this.tooltip = new SohoTooltipDirective(this.element) as SohoTooltipDirective;
    const placement = this.placement as SohoTooltipOffset;

    this.tooltip.content = this.content; // this.element.nativeElement.innerText;
    this.tooltip.placement = placement;
    this.tooltip.maxWidth = this.element.nativeElement.scrollWidth + 20; // additional 20px to offset the tooltip padding and display the whole description
    this.tooltip.ngAfterViewInit();
    this.tooltip.show();
  }

  private applyStyleOverflowEllipsis(): void {
    this.element.nativeElement.style.whitespace = 'nowrap';
    this.element.nativeElement.style.overflow = 'hidden';
    this.element.nativeElement.style.textOverflow = 'ellipsis';
  }
}
